import ComponentHeaderTwo from "common/ComponentHeaderTwo/ComponentHeaderTwo";
import type { BreadcrumbItem } from "Helpers/generalBreadcrumbs";
import { pickVehiclePlateNumber } from "Helpers/pickProfileEntityTitle";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { VehicleProfileService } from "subModule/src/core/services";
import { ReactComponent as Vehicle } from "../../assets/SideBarIcons/vehicle.svg";
import VehicleTabs from "./VehicleTabs";
import { Box } from "@mui/material";
import PaymentListing from "pages/Payment/PaymentListing";
export default function VehiclePayments() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const params = useParams();
    const vehicleId = params?.id;
    const [plateNumber, setPlateNumber] = useState("");

    useEffect(() => {
        if (!vehicleId) return;
        let active = true;
        VehicleProfileService.getVehicleByID(+vehicleId)
            .then((res: unknown) => {
                if (!active) return;
                const plate = pickVehiclePlateNumber(res);
                if (plate) setPlateNumber(plate);
            })
            .catch(() => {});
        return () => {
            active = false;
        };
    }, [vehicleId]);

    const breadcrumbItems: BreadcrumbItem[] = useMemo(
        () => [
            { labelKey: "vehicles" },
            { labelKey: "vehiclesList", href: "/vehicles" },
            {
                labelKey: "plateNumber",
                ...(plateNumber ? { label: plateNumber } : {}),
                href: vehicleId ? `/vehicle/${vehicleId}` : undefined,
            },
            { labelKey: "payments" },
        ],
        [vehicleId, plateNumber],
    );

    return (<>
        <ComponentHeaderTwo
            showBtn={true}
            showSaveBtn={false}
            onClick={() => navigate('/vehicles')}
            onSubmit={() => {}}
            heading={t('vehicles')}
            icon={<Vehicle height={28} width={28} />}
            btnText={"back"}
            btnType={"back"}
            showCreateBtn={false}
            breadcrumbItems={breadcrumbItems}
        />
        <Box className={`flex`}>
            <VehicleTabs params={params} selectedIndex={6} />
            <Box className='mt-[10px] w-[100%]'>
                <PaymentListing vehicleId={+(params as any)?.id} type='vehicle' />
            </Box>
        </Box>
    </>)
}
